import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import Store from "./store";
import SupportWidget from "./Global/SupportWidget/SupportWidget";

const mountSupportWidget = (config = {}) => {
  let container = document.getElementById("support-widget-root");

  if (!container) {
    container = document.createElement("div");
    container.id = "support-widget-root";
    Object.assign(container.style, {
      position: "fixed",
      bottom: "0px",
      right: "0px",
      zIndex: "999",
    });
    document.body.appendChild(container);
  }

  const root = createRoot(container);
  root.render(
    <Provider store={Store}>
      <SupportWidget token={config.token ?? null} />
    </Provider>
  );
};

// Expose globally
window.initSupportWidget = mountSupportWidget;

// Optional: auto-run if token is already set
if (window._pendingSupportConfig) {
  mountSupportWidget(window._pendingSupportConfig);
}
